import { css } from '@emotion/core';
import { typographyStyles, constants } from '@newsela/angelou';

const { textM, textS } = typographyStyles;

// Constants
export const ERROR_COLOR = constants.colors.ui.red[500];

// Common input base styles
const inputBase = css`
  padding: 12px;
  border: solid 1px ${constants.colors.ui.neutral[400]};
  border-radius: 8px;
`;

export const $filtersContainer = css`
  margin: 16px 32px 12px 32px;
`;

export const $subFiltersContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  label {
    width: auto;
    padding: 12px;
    position: relative;
    left: -12px;
    div:first-of-type {
      padding-right: 4px;
    }
  }
`;

export const $searchInput = [
  textM,
  inputBase,
  css`
    margin-right: 8px;
    flex: 1;
  `,
];

export const $customSelectContainer = [
  textM,
  css`
    padding: 8px 8px 8px 16px;
    border: solid 1px ${constants.colors.ui.neutral[400]};
    border-radius: 8px;
    overflow: hidden;
    color: ${constants.colors.ui.neutral[400]};
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
  `,
];

export const $chevronDown = css`
  width: 24px;
  height: 24px;
  margin-left: 8px;
`;

export const $yearInputContainer = [
  textS,
  css`
    color: ${constants.colors.ui.neutral[400]};
  `,
];

export const $yearInput = [
  css`
    min-width: 120px;
    height: 32px;
  `,
];
export const $to = [
  textM,
  css`
    margin-bottom: 12px;
    color: ${constants.colors.ui.neutral[700]};
  `,
];

export const $button = [
  textM,
  css`
    height: 48px;
  `,
];
export const $clearButton = [
  textM,
  css`
    height: 48px;
    min-width: 128px;
    align-items: center;
    justify-content: center;
  `,
];

export const $checkbox = css`
  padding-left: 1px;
  padding-right: 1px;
  outline: none !important;
  &:hover {
    background-color: #1D1D1D14;
  }
`;

export const $options = [
  textM,
  css`
    max-height: 200px;
    overflow-y: auto;
    color: ${constants.colors.ui.neutral[500]};
    min-width: 288px;
  `,
];

export const $customSelectLabel = [
  textS,
  css`
    font-weight: 700;
    color: ${constants.colors.ui.neutral[600]};
  `,
];

export const $buttonsContainer = css`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid ${constants.colors.ui.neutral[100]};
`;

export const $clearFilters = [
  textM,
  css`
  color: ${constants.colors.ui.core[700]};
  cursor: pointer;
  font-weight: 400;
`];

export const $errorMessage = [
  textS,
  css`
    color: ${ERROR_COLOR};
    padding: 0 8px;
    font-weight: 500;
  `,
];
